/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * The vehicle type:
 *   * LIGHT:
 *   * LDV:
 *   * HEAVY:
 *   * HEAVY_WITH_TRAILER:
 *   * BIKE:
 *   * MOTORBIKE:
 *   * GARBAGE_TRUCK:
 *   * BUS:
 *   * BOAT_LINER
 *   * BOAT_TOURISTIC
 *   * UNDEFINED
 */
export enum VehicleType {
  LIGHT = 'LIGHT',
  LDV = 'LDV',
  HEAVY = 'HEAVY',
  HEAVY_WITH_TRAILER = 'HEAVY_WITH_TRAILER',
  BIKE = 'BIKE',
  MOTORBIKE = 'MOTORBIKE',
  GARBAGE_TRUCK = 'GARBAGE_TRUCK',
  BUS = 'BUS',
  BOAT_LINER = 'BOAT_LINER',
  BOAT_TOURISTIC = 'BOAT_TOURISTIC',
  UNDEFINED = 'UNDEFINED'
}
